import {
  Base,
  Component,
  InjectReactive,
  Mixins
} from '@/vue-property-decorator'
import { GetCssVarManager } from '../../../../components/baseCssVarProvide'
import { _TriangleHeartBase as TriangleHeartBase } from './cssVar/triangleHeartBase'
import { _TriangleHeartDefault as TriangleHeartDefault } from './cssVar/triangleHeartDefault'
import BaseCssVarInject from '../../../../components/baseCssVarInject'
import style from './style.module.scss'
export { TriangleHeartBase, TriangleHeartDefault }
export type TriangleHeartCssVarManager = GetCssVarManager<TriangleHeartBase>

/** 三角形中间加个心型,都是普通图片,没有动画 */
@Component<TriangleHeart>({
  name: 'TriangleHeart'
})
export default class TriangleHeart extends Mixins<
  Base,
  BaseCssVarInject<TriangleHeartBase>
>(Base, BaseCssVarInject) {
  public static getTriangleHeartDefault = () => new TriangleHeartDefault()

  @InjectReactive()
  private isFavorited!: boolean
  render() {
    const imgUrl = this.isFavorited
      ? '/lobby_asset/{layout}-{bg}-{skin}/common/home/icon_dt_sc1.png'
      : '/lobby_asset/{layout}-{bg}-{skin}/common/home/icon_dt_sc.png'
    return (
      <div
        class={{
          [style['triangle-heart']]: true,
          [style[`type-${this.finialCssType}`]]: Boolean(this.finialCssType)
        }}
      >
        <my-img
          class={style['img-div']}
          src={imgUrl}
          options={{ type: 'div' }}
        />
      </div>
    )
  }
}
